import { render, staticRenderFns } from "./ccm-self-study.vue?vue&type=template&id=48d94c5e&"
import script from "./ccm-self-study.vue?vue&type=script&lang=js&"
export * from "./ccm-self-study.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports